<template>
  <div class="relative min-h-screen w-full overflow-hidden lg:grid lg:grid-cols-2">
    <!-- Fondo continuo que abarca ambas columnas (sin costura) -->
    <div class="absolute inset-0 bg-gradient-to-br from-card-dark via-[#131417] to-[#0B0C0E]"></div>

    <!-- Brand panel (solo desktop) -->
    <aside class="relative hidden overflow-hidden p-12 xl:p-16 lg:flex lg:flex-col lg:justify-between">
      <!-- Glow blobs -->
      <div class="pointer-events-none absolute -left-24 -top-32 h-96 w-96 rounded-full opacity-30 blur-3xl"
        style="background: radial-gradient(circle, rgba(11,129,239,0.45), transparent 65%);"></div>
      <div class="pointer-events-none absolute -bottom-48 -left-16 h-[34rem] w-[34rem] rounded-full opacity-[0.12] blur-3xl"
        style="background: radial-gradient(circle, rgba(34,197,94,0.35), transparent 70%);"></div>

      <!-- Textura de puntos -->
      <div class="absolute inset-0 opacity-[0.14]"
        style="background-image: radial-gradient(circle at 1px 1px, rgba(255,255,255,0.18) 1px, transparent 0); background-size: 26px 26px;">
      </div>

      <!-- Logo -->
      <div class="relative flex items-center gap-3">
        <img :src="logoSrc" alt="Finova" class="h-11 w-11 rounded-xl object-contain" />
        <span class="text-xl font-extrabold tracking-tight text-white">Finova</span>
      </div>

      <!-- Hero copy -->
      <div class="relative max-w-md">
        <h2 class="text-4xl font-extrabold leading-[1.1] tracking-tight text-white xl:text-5xl">
          Tu negocio entero, en&nbsp;un&nbsp;solo&nbsp;lugar.
        </h2>
        <p class="mt-5 text-lg leading-relaxed text-white/60">
          Finanzas, ventas, marketing, calendario, automatizaciones y Finova AI: gestiona y haz crecer tu empresa desde una sola plataforma.
        </p>
      </div>

      <!-- Footer del panel -->
      <div class="relative text-xs text-white/30">© {{ year }} Finova</div>
    </aside>

    <!-- Panel del formulario -->
    <div class="relative flex min-h-screen items-center justify-center px-4 py-10">
      <!-- Glow sutil detrás de la card en mobile -->
      <div class="pointer-events-none absolute -bottom-28 -right-28 h-80 w-80 rounded-full opacity-20 blur-3xl lg:hidden"
        style="background: radial-gradient(circle, rgba(11,129,239,0.45), transparent 60%);"></div>

      <div class="relative w-full max-w-md">
        <AuthForm ref="authForm" :options="options" :allowRegister="allowRegister" :userType="userType"
          :logoSrc="logoSrc" @onSubmit="onSubmit" @onError="onError" />
      </div>
    </div>
  </div>
</template>

<script>
import AuthForm from "./AuthForm.vue";

export default {
  props: {
    options: {
      type: Object,
      default: () => ({ magicLink: { enabled: true }, password: { enabled: true } })
    },
    userType: { type: String, required: true },
    allowRegister: { type: Boolean, default: true },
    logoSrc: { type: String, default: "./finova-logo.jpeg" }
  },
  components: { AuthForm },
  computed: {
    year() {
      return new Date().getFullYear();
    }
  },
  methods: {
    resetErrors() {
      this.$refs.authForm.resetErrors();
    },
    onSubmit(payload) {
      this.$emit("onSubmit", payload);
    },
    onError(error) {
      this.$emit("onError", error);
    }
  }
};
</script>
